import { useEffect, useState } from 'react';
import { Scroll, Loader2 } from 'lucide-react';
import { useAdmin } from '@/hooks/useAdmin';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminAuditLog() {
  const { authFetch } = useAdmin();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    authFetch(`${API}/admin/audit/log?limit=200`)
      .then(r => r.json())
      .then(d => setRows(d.entries || d.log || (Array.isArray(d) ? d : [])))
      .finally(() => setLoading(false));
  }, [authFetch]);

  return (
    <div className="p-4 md:p-6" data-testid="admin-audit-log">
      <div className="flex items-center gap-3 mb-6">
        <Scroll className="text-red-500" size={24} />
        <div>
          <h1 className="text-2xl font-bold">Revizijski zapis</h1>
          <p className="text-sm text-zinc-400">Svi admin događaji (uredi/brisanja/auto-publish).</p>
        </div>
      </div>
      {loading ? <Loader2 className="animate-spin text-zinc-500" /> : (
        <div className="overflow-x-auto rounded-lg border border-zinc-800">
          <table className="min-w-full text-xs">
            <thead className="bg-zinc-900 text-zinc-400 uppercase">
              <tr>
                <th className="px-3 py-2 text-left">Vrijeme</th>
                <th className="px-3 py-2 text-left">Akter</th>
                <th className="px-3 py-2 text-left">Akcija</th>
                <th className="px-3 py-2 text-left">Entitet</th>
                <th className="px-3 py-2 text-left">Detalji</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.id || i} className="border-t border-zinc-800">
                  <td className="px-3 py-1.5 text-zinc-500 whitespace-nowrap">{(r.created_at || r.timestamp || '').slice(0, 19).replace('T', ' ')}</td>
                  <td className="px-3 py-1.5 text-zinc-200">{r.actor_email || r.actor || '—'}</td>
                  <td className="px-3 py-1.5"><span className="inline-block px-2 py-0.5 rounded bg-zinc-800 text-zinc-300">{r.action || r.event || '—'}</span></td>
                  <td className="px-3 py-1.5 text-zinc-400">{r.entity_type || r.type || ''} {r.entity_id ? <code className="text-[10px]">{String(r.entity_id).slice(0, 8)}</code> : ''}</td>
                  <td className="px-3 py-1.5 text-zinc-500 max-w-md truncate">{r.reason || r.note || JSON.stringify(r.payload || {}).slice(0, 120)}</td>
                </tr>
              ))}
              {rows.length === 0 && <tr><td colSpan={5} className="px-3 py-8 text-center text-zinc-500">Prazan zapis.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
